<template>
    <Head>
        <title>{{title}}</title>
        <meta name="description" :content="description">
    </Head>
    <Header :agency="agency" :bg_img="bg_img"></Header>
    <Layout>

        <div class="content-blocks">


            <section class="page-header-section full-view-header vendre-header no-margin">
                <div class="image-block"
                     style="background-image: url('https://www.ewigo.com/wp-content/uploads/2026/01/ACHETEZ_EWIGO_1.png')">
                </div>
                <div class="container">
                    <div class="content">
                        <h1 class="h1 white anim fade right">Choisissez la meilleure solution</h1>
                        <h4 class="h4 white anim fade right delay1">et estimez votre véhicule gratuitement</h4>
                    </div>
                    <div class="search-block anim fade up delay2">
                        <form class="form-block" :action="route('minisite.landing-page-reprise-depot')" method="GET">
                            <div class="input-box">
                                <input type="text" placeholder="Numéro d’immatriculation" name="registration">
                            </div>
                            <div class="submit-button">
                                <input type="submit">
                            </div>
                        </form>
                        <!--
                        <p class="white">ou</p>
                        <div class="button">
                            <a :href="route('minisite.landing-page')" class="btn dull-btn">Je n’ai pas mon numéro d’immatriculation </a>
                        </div>
                        -->
                    </div>
                </div>
                <a href="#expertise-personalized" class="down-btn scroll-to"></a>
            </section>


            <section class="expertise-personalized" id="expertise-personalized">
                <div class="container">
                    <div class="row">
                        <h2 class="h2 anim fade left">Une expertise personnalisée</h2>
                    </div>
                    <div class="row">

                        <div class="hourglass"><img
                            src="https://www.ewigo.com/wp-content/uploads/2022/02/iStock-485490069-removebg-preview-1-trimmy.png"
                            alt=""></div>


                        <div class="col-lg-6 left-row">
                            <div class="image-block anim flip"><img
                                src="https://www.ewigo.com/wp-content/uploads/2022/02/icone-temps.svg" alt="">
                            </div>
                            <h3 class="h3 anim fade left">Besoin d'une vente rapide ?</h3>
                            <p class="anim fade left">
                            <ul>
                                <li>Rachat immédiat de votre véhicule</li>
                                <li>Versement des fonds sous 48 heures</li>
                                <li>Paiement sécurisé</li>
                                <li>Aucun frais de remise en état du véhicule</li>
                                <li>Reprise de la responsabilité juridique de votre véhicule</li>
                            </ul>
                            </p>
                        </div>
                        <div class="col-lg-6 right-row">
                            <div class="image-block anim fade left"><img
                                src="https://www.ewigo.com/wp-content/uploads/2022/02/icone-argent.svg"
                                alt=""></div>
                            <h3 class="h3 anim fade left">Sensible à un meilleur prix ?</h3>
                            <p class="anim fade right" style="text-align: left;">
                            <ul>
                                <li>Pas d&rsquo;urgence de vente (vente sous 20 jours en moyenne)</li>
                                <li>20% de gain sur le prix de vente de votre véhicule</li>
                                <li>Commercialisation de votre véhicule</li>
                                <li>Véhicule garanti minimum 6 mois</li>
                                <li>Visibilité maximale de votre véhicule (reportage photo HD)</li>
                                <li>Gestion des démarches administratives en toute sécurité</li>
                            </ul>
                            </p>
                        </div>
                    </div>
                </div>
            </section>


            <section class="video-with-content-section ">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6 display-mobile">
                            <a :href="route('minisite.landing-page-reprise-depot')"
                            class="btn primary-btn anim fade left">Vendre mon véhicule</a>
                        </div>
                        <div class="col-lg-6">
                            <div class="video-block anim fade right">
                                <iframe width="1280" height="370"
                                        src="https://www.youtube.com/embed/X0N1ZO7L06M?autoplay=0"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <p class="anim fade left">
                                <p class="center-mobile"><b>Xavier Demangeat, 1er franchisé et Directeur Général
                                d’Ewigo</b></p><br><br> Au travers de ce témoignage, découvrez comment les ambassadeurs
                                du réseau Ewigo ont à cœur de simplifier la vie de plus de 80.000 clients dans leurs
                                projets auto. Tout ceci pour vous permettre de prendre enfin du plaisir dans la vente de
                                votre véhicule en toute sécurité ! </p> <a
                            :href="route('minisite.landing-page-reprise-depot')"
                            class="btn primary-btn anim fade left display-desktop">Vendre mon véhicule</a>
                        </div>
                    </div>
                </div>
            </section>


            <section class="seperator-section"
                     style="background-image: url('https://www.ewigo.com/wp-content/uploads/2021/09/Mask-Group-47-e1631285247735.png')">
                <div class="container">
                    <h3 class="h3 white anim fade up">Les 5 étapes de la vente</h3>
                </div>
            </section>


            <section class="stages-of-the-sale-section">
                <div class="container">


                    <div class="list-block version-desktop">
                        <div class="list">
                            <div class="row">
                                <div class="col-12 col-md-8">
                                    <div class="content-block anim fade right">
                                        <div class="count">1.</div>
                                        <div class="value">
                                            <h2 class="h2">Vérification</h2>
                                            <p class="">Un conseiller réalise au sein du point de vente
                                                différents points de contrôle nous permettant de nous assurer que le
                                                véhicule correspond bien à notre charte de qualité. L’objectif :
                                                pouvoir s’assurer de présenter des véhicules qualitatifs avec un
                                                historique d’entretien limpide. </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="image-block anim fade up right-img"><img
                                        src="https://www.ewigo.com/wp-content/uploads/2026/01/VERIFICATION_AUTO_EWIGO.png"
                                        alt=""></div>
                                </div>
                            </div>
                        </div>
                        <div class="list">
                            <div class="row">
                                <div class="col-12 col-md-8">
                                    <div class="content-block anim fade left">
                                        <div class="count">2.</div>
                                        <div class="value">
                                            <h2 class="h2">Estimation</h2>
                                            <p class="">Une fois le contrôle du véhicule effectué, nous déterminons
                                                ensemble le prix de vente professionnel de celui-ci. Le but est de vous
                                                faire bénéficier du meilleur prix de marché. C’est vous qui décidez !
                                                Nous sommes là pour vous apporter nos meilleurs conseils. </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="image-block anim fade up left-img"><img
                                        src="https://www.ewigo.com/wp-content/uploads/2026/01/ESTIMATION_AUTO_EWIGO.png"
                                        alt=""></div>
                                </div>
                            </div>
                        </div>
                        <div class="list">
                            <div class="row">
                                <div class="col-12 col-md-8">
                                    <div class="content-block anim fade right">
                                        <div class="count">3.</div>
                                        <div class="value">
                                            <h2 class="h2">Commercialisation</h2>
                                            <p class="">Nous signons ensemble un mandat semi-exclusif d’une durée de
                                                deux mois nous permettant de commercialiser dans les meilleures
                                                conditions votre véhicule. Ceci nous permettra de donner une grande
                                                visibilité à votre annonce via l’ensemble de nos partenaires de
                                                diffusion. Vous restez propriétaire de votre véhicule et pouvez
                                                continuer de l’utiliser durant sa commercialisation. </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="image-block anim fade up right-img"><img
                                        src="https://www.ewigo.com/wp-content/uploads/2026/01/COMMERCIALISATION_AUTO_EWIGO.png"
                                        alt=""></div>
                                </div>
                            </div>
                        </div>
                        <div class="list">
                            <div class="row">
                                <div class="col-12 col-md-8">
                                    <div class="content-block anim fade left">
                                        <div class="count">4.</div>
                                        <div class="value">
                                            <h2 class="h2">Promotion</h2>
                                            <p class="">Votre interlocuteur privilégié, accompagné des ambassadeurs du
                                                réseau, met tout en œuvre pour promouvoir votre véhicule auprès de notre
                                                base d’acheteurs nationale. Vous serez tenu informé de tout ! Chaque
                                                semaine, votre conseiller fera un point d’étape sur l’avancement de
                                                votre projet de vente. Dès qu’un acheteur sérieux est identifié, la
                                                présentation de votre véhicule sera organisée par nos soins directement
                                                en point de vente. </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="image-block anim fade up left-img"><img
                                        src="https://www.ewigo.com/wp-content/uploads/2026/01/PROMOTION_AUTO_EWIGO.png"
                                        alt=""></div>
                                </div>
                            </div>
                        </div>
                        <div class="list">
                            <div class="row">
                                <div class="col-12 col-md-8">
                                    <div class="content-block anim fade right">
                                        <div class="count">5.</div>
                                        <div class="value">
                                            <h2 class="h2">Sécurisation</h2>
                                            <p class="">La réservation du véhicule effectuée, nous nous occupons de la
                                                sécurisation de la transaction et de l’ensemble des démarches
                                                administratives inhérentes à la vente. Les flux financiers seront
                                                sécurisés par le biais d’un compte séquestre, comme chez un notaire ! Le
                                                transfert de propriété sera déclaré en préfecture afin de clôturer
                                                l’opération. </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="image-block anim fade up right-img"><img
                                        src="https://www.ewigo.com/wp-content/uploads/2026/01/SECURISATION_AUTO_EWIGO.png"
                                        alt=""></div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </section>


            <section class="questionaries-section">
                <div class="questionaries">
                    <div class="content-block">
                        <h2 class="h3 anim fade up">Questions fréquentes</h2>
                        <div class="list-block row"
                             style="background-image: url('https://www.ewigo.com/wp-content/uploads/2026/01/QUESTION_EWIGO.png');">
                            <div class="list col-md-4">
                                <div class="content">
                                    <p class="anim fade up"><a :href="route('minisite.faq')">Puis-je utiliser mon véhicule pendant la commercialisation ?</a></p>
                                </div>
                            </div>
                            <div class="list col-md-4">
                                <div class="content">
                                    <p class="anim fade up"><a :href="route('minisite.faq')">Comment se passe le paiement avec Ewigo ?</a></p>
                                </div>
                            </div>
                            <div class="list col-md-4">
                                <div class="content">
                                    <p class="anim fade up"><a :href="route('minisite.faq')">Mon véhicule est hors charte. Qu’est-ce que cela signifie ?</a></p>
                                </div>
                            </div>
                            <div class="list col-md-4">
                                <div class="content">
                                    <p class="anim fade up"><a :href="route('minisite.faq')">Aurais-je un interlocuteur direct pendant la vente de mon véhicule ?</a>
                                    </p>
                                </div>
                            </div>
                            <div class="list col-md-4">
                                <div class="content">
                                    <p class="anim fade up"><a :href="route('minisite.faq')">Vendre ma voiture avec ewigo, c’est gratuit ?</a></p>
                                </div>
                            </div>
                            <div class="list col-md-4">
                                <div class="content">
                                    <p class="anim fade up"><a :href="route('minisite.faq')">Comment est calculé le prix de ma voiture ?</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="testimonial-section">
                    <div class="content-block">
                        <h2 class="h3 white">Ils nous ont fait confiance</h2>
                        <div class="testimonial-block">
                            <template v-if="showFakeReviews === false && reviews.length > 0">
                                <div class="slide" v-for="(review, index) in reviews" :key="`review-${review.id}-${index}`">
                                    <div class="testimonial slide anim fade left">
                                        <div class="content">
                                            <div class="author">
                                                <div class="headshot"
                                                     style="background-image: url();">
                                                </div>
                                                <p class="title bold">{{review.author_name}}</p>
                                                <div class="rating"></div>
                                            </div>
                                            <p class="message">{{review.text.substring(0,200)+"..."}}</p>
                                            <p class="designation">Agence {{agency.name}}</p>
                                            <p class="time">{{review.relative_time_description}}</p>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="showFakeReviews">
                                <div v-for="n in 5" class="slide" :key="`review-${n}`">
                                    <div class="testimonial slide anim fade left">
                                        <div class="content">
                                            <div class="author">
                                                <div class="headshot"
                                                     style="background-image: url();">
                                                </div>
                                                <p class="title bold">Benoit T.</p>
                                                <div class="rating"></div>
                                            </div>
                                            <p class="message">Nos inspecteurs automobiles effectuent 100 points de
                                                contrôle, un essai routier et l’historique est vérifié sur chacun de nos
                                                véhicules.</p>
                                            <p class="designation">Agence de La Rochelle</p>
                                            <p class="time">Il y a 3 semaines</p>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </section>


            <section class="find-us-near-you-section" id="trouver-agence">
                <div class="image-block"
                     style="background-image: url('https://www.ewigo.com/wp-content/uploads/2026/01/ACHETEZ_EWIGO_1.png')">
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <h2 class="h2 white anim fade right">Contactez votre point de vente Ewigo {{ agency.city }}</h2>
                        <!-- Trouvez une agence près de chez vous -->
                        <p class="white anim fade right">
                            <!-- <svg fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="20px" height="20px"><path d="M 14 3.9902344 C 8.4886661 3.9902344 4 8.4789008 4 13.990234 L 4 35.990234 C 4 41.501568 8.4886661 45.990234 14 45.990234 L 36 45.990234 C 41.511334 45.990234 46 41.501568 46 35.990234 L 46 13.990234 C 46 8.4789008 41.511334 3.9902344 36 3.9902344 L 14 3.9902344 z M 14 5.9902344 L 36 5.9902344 C 40.430666 5.9902344 44 9.5595687 44 13.990234 L 44 35.990234 C 44 40.4209 40.430666 43.990234 36 43.990234 L 14 43.990234 C 9.5693339 43.990234 6 40.4209 6 35.990234 L 6 13.990234 C 6 9.5595687 9.5693339 5.9902344 14 5.9902344 z M 18.048828 11.035156 C 16.003504 10.946776 14.45113 11.723922 13.474609 12.658203 C 12.986349 13.125343 12.633832 13.625179 12.392578 14.091797 C 12.151324 14.558415 11.998047 14.943108 11.998047 15.443359 C 11.998047 15.398799 11.987059 15.632684 11.980469 15.904297 C 11.973869 16.17591 11.97507 16.542045 12 16.984375 C 12.04996 17.869036 12.199897 19.065677 12.597656 20.484375 C 13.393174 23.321771 15.184446 27.043821 19.070312 30.929688 C 22.95618 34.815554 26.678014 36.606575 29.515625 37.402344 C 30.93443 37.800228 32.130881 37.949937 33.015625 38 C 33.457997 38.02503 33.822105 38.026091 34.09375 38.019531 C 34.365395 38.012931 34.601049 38.001953 34.556641 38.001953 C 35.056892 38.001953 35.441585 37.848676 35.908203 37.607422 C 36.374821 37.366168 36.874657 37.013651 37.341797 36.525391 C 38.276078 35.54887 39.053222 33.996496 38.964844 31.951172 C 38.922907 30.975693 38.381316 30.111858 37.582031 29.599609 C 36.96435 29.203814 36.005458 28.589415 34.753906 27.789062 C 33.301811 26.861299 31.44451 26.795029 29.929688 27.625 L 30.015625 27.582031 L 28.837891 28.087891 L 28.751953 28.148438 C 28.465693 28.349428 28.111154 28.386664 27.789062 28.251953 C 26.886813 27.874649 25.480985 27.133329 24.173828 25.826172 C 22.866671 24.519015 22.125351 23.113186 21.748047 22.210938 C 21.613336 21.888845 21.650568 21.534307 21.851562 21.248047 L 21.912109 21.162109 L 22.417969 19.984375 L 22.375 20.070312 C 23.204764 18.555868 23.140248 16.698619 22.210938 15.246094 C 21.410584 13.994542 20.796186 13.03565 20.400391 12.417969 C 19.888142 11.618684 19.02431 11.077096 18.048828 11.035156 z M 17.962891 13.033203 C 18.243409 13.045263 18.533045 13.209378 18.716797 13.496094 C 19.113001 14.114413 19.727696 15.07377 20.527344 16.324219 C 21.058033 17.153694 21.09533 18.243821 20.621094 19.109375 L 20.597656 19.152344 L 20.115234 20.279297 L 20.214844 20.097656 C 19.623835 20.939396 19.505055 22.032514 19.902344 22.982422 C 20.35304 24.060173 21.214923 25.695392 22.759766 27.240234 C 24.304608 28.785077 25.939827 29.64696 27.017578 30.097656 C 27.967486 30.494945 29.060604 30.376165 29.902344 29.785156 L 29.720703 29.884766 L 30.847656 29.402344 L 30.890625 29.378906 C 31.755801 28.904877 32.845877 28.944375 33.675781 29.474609 L 33.675781 29.472656 C 34.92623 30.272304 35.885587 30.886999 36.503906 31.283203 C 36.790622 31.466955 36.954736 31.756591 36.966797 32.037109 C 37.032417 33.555785 36.504954 34.506599 35.896484 35.142578 C 35.59225 35.460568 35.262335 35.691348 34.990234 35.832031 C 34.718133 35.972715 34.457889 36.001953 34.556641 36.001953 C 34.373232 36.001953 34.276633 36.013981 34.046875 36.019531 C 33.817117 36.025131 33.509144 36.025436 33.128906 36.003906 C 32.368431 35.960876 31.318757 35.831053 30.054688 35.476562 C 27.526547 34.767581 24.137509 33.168759 20.484375 29.515625 C 16.831241 25.862491 15.232169 22.473167 14.523438 19.945312 C 14.169071 18.681386 14.039037 17.631464 13.996094 16.871094 C 13.974624 16.490908 13.974899 16.18286 13.980469 15.953125 C 13.986069 15.72339 13.998047 15.626918 13.998047 15.443359 C 13.998047 15.542109 14.027287 15.281867 14.167969 15.009766 C 14.308652 14.737665 14.539432 14.40775 14.857422 14.103516 C 15.493401 13.495046 16.444215 12.967581 17.962891 13.033203 z"/></svg> -->
                            Tel : {{ agency.phone }}</p>
                        <p class="white anim fade right">Mail : {{ agency.email }}</p>
                        <p class="white anim fade right">Adresse : {{ agency.address }}</p>
                        <p class="white anim fade right">{{ agency.postcode }} {{ agency.city }}</p>
                        <!-- <p class="white anim fade right">Ne manquez rien de nos actualités en vous abonnant à la
                            newsletter</p> -->
                        <!-- <div class="search-block anim fade right">
                            <div class="button">
                                <a href="#" class="btn primary-btn">Activer ma localisation</a>
                            </div>
                            <p class="white">ou</p>
                            <div class="form-block">
                                <div class="input-box">
                                    <input type="text" placeholder="Code postal de la ville ">
                                </div>
                                <div class="submit-button">
                                    <input type="submit">
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="col-lg-6 map-container">
                        <!--<img :src="agency.photo_url" alt="photo agence" loading="lazy">-->


                        <iframe width="600" height="450" id="gmap_canvas"
                                :src="`https://maps.google.com/maps?q=ewigo%20${agency.city}&t=&z=13&ie=UTF8&iwloc=&output=embed`"
                                frameborder="0" scrolling="no" marginheight="0" marginwidth="0" loading="lazy"></iframe>


                    </div>
                </div>
            </section>


            <section class="logos-block-section ">
                <div class="container">
                    <h2 class="h2 center anim fade up">Les médias parlent de nous</h2>
                    <div class="images">
                        <div class="image-block anim fade up"><img
                            src="https://www.ewigo.com/wp-content/uploads/2021/10/news-1.png" alt=""></div>
                        <div class="image-block anim fade up"><img
                            src="https://www.ewigo.com/wp-content/uploads/2021/10/news-2.png" alt=""></div>
                        <div class="image-block anim fade up"><img
                            src="https://www.ewigo.com/wp-content/uploads/2021/10/news-3.png" alt=""></div>
                        <div class="image-block anim fade up"><img
                            src="https://www.ewigo.com/wp-content/uploads/2021/10/news-4.png" alt=""></div>
                        <div class="image-block anim fade up"><img
                            src="https://www.ewigo.com/wp-content/uploads/2021/10/news-5.png" alt=""></div>
                    </div>
                </div>
            </section>


            <section class="newsletter-section">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <h2 class="h2 white anim fade up">Newsletter</h2>
                            <p class="white title anim fade up delay1">Suivez toutes nos actualités en vous abonnant à
                                la newsletter</p>
                            <div class="anim fade up delay2">
                                <div role="form" class="wpcf7" id="wpcf7-f48-p326-o1" lang="en-US" dir="ltr">
                                    <div class="screen-reader-response">
                                        <p role="status" aria-live="polite" aria-atomic="true"></p>
                                        <ul></ul>
                                    </div>
                                    <form action="/ewigo_website/vendre/#wpcf7-f48-p326-o1" method="post"
                                          class="wpcf7-form init" novalidate="novalidate" data-status="init">
                                        <div class="form-newsletter">
                                            <div class="email-box">
                                                <span class="wpcf7-form-control-wrap your-email"><input type="email"
                                                                                                        name="your-email"
                                                                                                        value="Email"
                                                                                                        size="40"
                                                                                                        class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                                                                                                        aria-required="true"
                                                                                                        aria-invalid="false"/></span>
                                            </div>
                                            <div class="submit-button">
                                                <input type="submit" value="Submit"
                                                       class="wpcf7-form-control has-spinner wpcf7-submit"
                                                       id="form_newsletter_submit"
                                                />
                                            </div>
                                        </div>
                                        <div class="wpcf7-response-output" aria-hidden="true"></div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                </div>
            </section>


        </div>

    </Layout>
    <Footer :agency="agency" :bg_img="bg_img"></Footer>
</template>

<script>
import _, {throttle} from 'lodash';
import Layout from './Ads/Layout'
import {Head} from '@inertiajs/inertia-vue3'
import Footer from "@/Pages/Partials/Footer"
import Header from "@/Pages/Partials/Header"
import Ad from "@/Pages/Partials/Ad"

export default {
    components: {
        Head,
        Layout,
        Footer,
        Header,
        Ad,
    },
    props: {
        agency: Object,
        title: String,
        description: String,
        bg_img: String,
        body_class: String,
        ads: Object,
        members: Object,
        update_date: String,
    },
    data() {
        return {
            reviews: [],
            showFakeReviews: false,
        }
    },
    methods: {
        getReviews() {
            axios.get(`${this.$page.props.ewigoExtranetUrl}/api/get/reviews/${this.agency.id_ewigo}`)
                .then((response) => {
                    this.showFakeReviews = false;
                    this.reviews = response.data.data;
                    $(document).ready(function () {
                        $(".testimonial-section .testimonial-block").slick('refresh');
                    });
                })
                .catch((error) => {
                    if (error) {
                        this.showFakeReviews = true;
                        this.reviews = [];
                        $(document).ready(function () {
                            $(".testimonial-section .testimonial-block").slick('refresh');
                        });
                    }
                })
        },
    },
    created() {
        this.getReviews();
    },
    mounted() {
        document.body.classList.add(this.body_class.split(' '));
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                const elToGoPosition = document.querySelector(this.getAttribute('href')).getBoundingClientRect().top + window.pageYOffset;
                const headerHeight = document.getElementById('masthead').getBoundingClientRect().height;
                window.scrollTo({
                    top: elToGoPosition - headerHeight,
                    behavior: 'smooth'
                });

                // document.querySelector(this.getAttribute('href')).scrollIntoView({
                //     behavior: 'smooth'
                // });
            });
        });
    },
    destroyed() {
        document.body.classList.remove(this.body_class.split(' '))
    }
}
</script>
<style lang="scss" scoped>
h3.anim.fade.left {
    padding-top: 5px;
}
/* .right img {
    border-radius: 100px 0 100px 0;
}
.left img {
    border-radius: 100px 0 100px 0;
} */
.image-block.right-img img{
    border-radius: 200px 0 0 200px;
}
.image-block.left-img img{
    border-radius: 0 200px 200px 0;
}
.expertise-personalized {
    margin-bottom: 0;
}
.video-with-content-section {
    padding: 50px 0;
}
.display-mobile {
    display: none;
}
.stages-of-the-sale-section {
    padding: 20px 0;
    .list {
        padding: 15px 0;
    }
}

@media screen and (max-width:991px) {
    .video-with-content-section {
        padding-top: 0;
        .video-block {
            margin-top: 30px;
        }
        .row {
            flex-direction: column-reverse;
        }
        a  {
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .display-mobile {
        display: block;
    }
    .display-desktop {
        display: none;
    }

    .stages-of-the-sale-section img {
        max-width: 85% !important;
    }

    .questionaries .list-block .list a {
        padding: 10px 20px;
    }

    .map-container {
        margin: 20px;
    }
    .center-mobile {
        text-align:center;
    }
    .logos-block-section .image-block {
        padding: 5px;
    }
}

.seperator-section h3{
    font-size: 2.65rem;
}

.logos-block-section .images {
    padding-top: 30px;
}
</style>
